import React from "react";
import ContentLoader from "react-content-loader";

const SelectSkeleton = (props) => (
  <ContentLoader
    speed={2}
    width={633}
    height={47}
    viewBox="0 0 633 47"
    backgroundColor="#e6e6e6"
    foregroundColor="#d1d1d1"
    {...props}
  >
    <path d="M 0 0 h 101 v 16 H 0 z M 0 29 h 21 v 18 H 0 z M 134 29 h 21 v 18 h -21 z M 268 29 h 21 v 18 h -21 z M 393 29 h 22 v 18 h -22 z M 520 29 h 21 v 18 h -21 z M 23 29 h 90 v 18 H 23 z M 158 29 h 89 v 18 h -89 z M 292 29 h 88 v 18 h -88 z M 418 29 h 89 v 18 h -89 z M 543 29 h 90 v 18 h -90 z" />
  </ContentLoader>
);

export default SelectSkeleton;
